
define('text!libs/strand/gulp/templates/lib_index_template.html',[],function () { return '<link rel="import" href="//wc.mediamath.com/{{rev}}/lib.html?p=compass" />';});

